import {AfterViewInit, Component} from '@angular/core';
import {LayoutManagerService} from '../../layout-manager.service';
import {Router} from '@angular/router';
import {timer} from 'rxjs';

declare  var jQuery:  any;

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.css']
})
export class HomeContentComponent implements AfterViewInit {

  loaded = false

  testString = ['Potenza','Rapidità', 'Semplicità', 'Affidabilità']
  countAnim = 0;
  animState = 0;
  tmpString = '';
  tmpCount = 0;
  countBreak = 0;

  constructor(
    private layoutManager: LayoutManagerService,
    private router: Router
  ) {
    this.charAnimation()
    this.layoutManager.updateSizes(window.innerWidth, window.innerHeight);
    this.loaded = true
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

  redirect(url) {
    window.open(url, "_blank");
  }

  telegramRedirect() {
    window.open("https://t.me/autoassets", "_blank");
  }

  partnersRedirect() {
    this.router.navigateByUrl('partners')
  }

  charAnimation() {
    const source = timer(2000, 70);
    const abc = source.subscribe(val => {
      if(this.countBreak == 0) {
        switch (this.animState) {
          case 0:
            if (this.tmpString.length == this.testString[this.countAnim].length) {
              this.animState = 1;
              this.countBreak = 15;
            } else {
              this.countBreak = 2;
              this.tmpString += this.testString[this.countAnim].charAt(this.tmpCount++)
            }
            break;
          case 1:
            if (this.tmpString.length == 0) {
              this.countAnim++;
              if (this.countAnim == this.testString.length)
                this.countAnim = 0
              this.animState = 0;
            } else {
              this.tmpString = this.tmpString.substr(0, this.tmpCount--)
            }
          default:
            break;
        }
      }else
        this.countBreak--;
    });
  }

  ngAfterViewInit(){
    ( function ( $ ) {
      "use strict";
      var carousel = $( ".carousel" );
      function doAnimations( elems ) {
        console.log('loadpage2');
        //Cache the animationend event in a variable
        var animEndEv = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elems.each( function ( ) {
          var $this = $( this ),
            $animationType = $this.data( 'animation' );
          $this.addClass( $animationType ).one( animEndEv, function ( ) {
            $this.removeClass( $animationType );
          } );
        } );
      }

      //Variables on page load
      var $firstAnimatingElems = carousel.find( '.carousel-item:first' ).find( "[data-animation ^= 'animated']" );
      //Initialize carousel
      carousel.carousel( );
      //Animate captions in first slide on page load
      doAnimations( $firstAnimatingElems );
      console.log('firstload');
      //Other slides to be animated on carousel slide event
      carousel.on( 'slide.bs.carousel', function ( e ) {
        var $animatingElems = $( e.relatedTarget ).find( "[data-animation ^= 'animated']" );
        doAnimations( $animatingElems );
      } );
    } )( jQuery );


    // CODE 2 for static-slider 2



  }

}
